export type ShopKind =
  | 'ship-upgrade'
  | 'suit-upgrade'
  | 'weapon-tool'
  | 'trade-terminal';

export interface ShopDefinition {
  readonly kind: ShopKind;
  readonly displayName: string;
  readonly tagline: string;
  readonly signText: string;
  readonly accent: number;
  readonly accentGlow: number;
  readonly vendorPreset: VendorPreset;
  readonly icon: string;
  readonly promptLabel: string;
}

export type VendorPreset =
  | 'engineer-human'
  | 'technician-alien'
  | 'arms-human'
  | 'trader-alien';

export const SHOP_DEFINITIONS: Record<ShopKind, ShopDefinition> = {
  'ship-upgrade': {
    kind: 'ship-upgrade',
    displayName: 'Engineering Bay',
    tagline: 'Ship upgrades and modules',
    signText: 'ENGINEERING',
    accent: 0x6ac0ff,
    accentGlow: 0x9fd9ff,
    vendorPreset: 'engineer-human',
    promptLabel: 'Open engineering',
    icon: `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M4 20 L16 4 L28 20 L22 26 L10 26 Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
  <line x1="16" y1="10" x2="16" y2="26" stroke="currentColor" stroke-width="2"/>
</svg>`
  },
  'suit-upgrade': {
    kind: 'suit-upgrade',
    displayName: 'Suit Atelier',
    tagline: 'Exosuit refinement',
    signText: 'EXOSUIT',
    accent: 0xffa063,
    accentGlow: 0xffd3a3,
    vendorPreset: 'technician-alien',
    promptLabel: 'Open atelier',
    icon: `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <circle cx="16" cy="9" r="5" fill="none" stroke="currentColor" stroke-width="2"/>
  <path d="M7 26 C7 18 11 14 16 14 C21 14 25 18 25 26 Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`
  },
  'weapon-tool': {
    kind: 'weapon-tool',
    displayName: 'Armory',
    tagline: 'Weapons and FPS tools',
    signText: 'ARMORY',
    accent: 0xff7272,
    accentGlow: 0xffb4b4,
    vendorPreset: 'arms-human',
    promptLabel: 'Open armory',
    icon: `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="4" y="14" width="18" height="4" rx="1" fill="none" stroke="currentColor" stroke-width="2"/>
  <path d="M22 12 L28 12 L28 20 L22 20 Z" fill="none" stroke="currentColor" stroke-width="2"/>
  <line x1="10" y1="18" x2="10" y2="24" stroke="currentColor" stroke-width="2"/>
</svg>`
  },
  'trade-terminal': {
    kind: 'trade-terminal',
    displayName: 'Trade Terminal',
    tagline: 'Convert ores into credits',
    signText: 'MARKET',
    accent: 0xf5c542,
    accentGlow: 0xffe38a,
    vendorPreset: 'trader-alien',
    promptLabel: 'Open market',
    icon: `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <circle cx="16" cy="16" r="10" fill="none" stroke="currentColor" stroke-width="2"/>
  <text x="16" y="21" text-anchor="middle" font-family="Inter, sans-serif" font-size="14" font-weight="700" fill="currentColor">$</text>
</svg>`
  }
};

export const SHOP_ORDER: readonly ShopKind[] = [
  'ship-upgrade',
  'suit-upgrade',
  'weapon-tool',
  'trade-terminal'
];

export function getShopDefinition(kind: ShopKind): ShopDefinition {
  return SHOP_DEFINITIONS[kind];
}
